import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button 
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'primary';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'primary'
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 'var(--border-radius-md)',
          padding: 0
        }
      }}
    >
      <DialogTitle sx={{ 
        color: 'var(--neutral-dark)',
        fontFamily: 'inherit',
        fontSize: '18px',
        fontWeight: 'bold',
        padding: 'var(--spacing-l)',
        paddingBottom: 'var(--spacing-m)'
      }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ 
        padding: '0 var(--spacing-l)',
        paddingBottom: 'var(--spacing-m)',
        color: 'var(--neutral-dark)',
        fontFamily: 'inherit',
        fontSize: '14px',
        lineHeight: 1.5
      }}>
        {message}
      </DialogContent>
      <DialogActions sx={{ 
        padding: 'var(--spacing-l)',
        paddingTop: 0,
        gap: 'var(--spacing-m)',
        justifyContent: 'flex-end'
      }}>
        <Button 
          onClick={onCancel}
          sx={{
            padding: 'var(--spacing-s) var(--spacing-m)',
            borderRadius: 'var(--border-radius-sm)',
            fontFamily: 'inherit',
            fontSize: '14px',
            textTransform: 'none',
            color: 'var(--neutral-dark)',
            border: '1px solid var(--neutral-light)',
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: '#F5F5F5'
            }
          }}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm}
          variant="contained"
          sx={{
            padding: 'var(--spacing-s) var(--spacing-m)',
            borderRadius: 'var(--border-radius-sm)',
            fontFamily: 'inherit',
            fontSize: '14px',
            textTransform: 'none',
            backgroundColor: variant === 'danger' ? 'var(--accent-color)' : 'var(--primary-color)',
            '&:hover': {
              backgroundColor: variant === 'danger' ? '#C02952' : '#277a64'
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog; 